var Alberta = "亞伯達省";
var Manitoba = "曼尼托巴省";
var Nunavut = "努勒維特";
var Ontario = "安大略省";
var Quebec = "魁北克省";
var Saskatchewan = "薩克其萬省";
var Yukon = "育空";
var CAStates = {
	Alberta: Alberta,
	"British Columbia": "卑詩省",
	Manitoba: Manitoba,
	"New Brunswick": "新伯倫瑞克省",
	"Newfoundland and Labrador": "紐芬蘭及拉布拉多省",
	"Northwest Territories": "西北領地",
	"Nova Scotia": "新斯科細亞省",
	Nunavut: Nunavut,
	Ontario: Ontario,
	"Prince Edward Island": "愛德華王子島",
	Quebec: Quebec,
	Saskatchewan: Saskatchewan,
	Yukon: Yukon
};

export { Alberta, Manitoba, Nunavut, Ontario, Quebec, Saskatchewan, Yukon, CAStates as default };
